'use client';

import { FC } from 'react';
import styles from './DialogContent.module.css';
import { DialogContentProps } from './DialogContent.types';
import { getClasses } from '@/_utils/classnames';

export const DialogContent: FC<DialogContentProps> = ({
  children,
  disablePadding,
  isOverflowing,
}) => {
  const dialogContentClasses: string = getClasses(styles.dialogContent, {
    [styles.dialogContentOverflowing]: isOverflowing,
    [styles.dialogContentNoPadding]: disablePadding,
  });

  return <div className={dialogContentClasses}>{children}</div>;
};
